export default "__VITE_ASSET__D0Cv0QxU__"